import React, { useEffect, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import {timesheetuserService} from '../services/timesheetUserservice';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaArrowAltCircleRight, FaArrowRight, FaAngleRight, FaBars } from "react-icons/fa";
import { MdOutlineCancel,MdOutlineClear  } from "react-icons/md";
import {loader} from '../compnents/loadermd';
import PaginationExample from '../compnents/pagination';
import { Dialog } from 'primereact/dialog';
import { Paginator } from 'primereact/paginator';
import { TabMenu } from 'primereact/tabmenu';
import  Addproject from './adminpages/addproject';
import  Addtask from './adminpages/addtask';
import Addbudgethrs from './adminpages/addbudgethrs';
import Addroles from './adminpages/addroles'; 
import Adddepartment from './adminpages/adddepartment';  
import Addteams from './adminpages/addteams';
import Addclient from './adminpages/addclient';  
import Clientmerger from './adminpages/clientmerger';  
import Clientassign from './adminpages/clientassign';  
import Budgetclientwise from './adminpages/budgetclientwise';  
import Mapmainclient from './adminpages/mapmainclient';  
import Permissions from './adminpages/permissions';  
import Addholiday from './adminpages/addholidays';  
import SubClientmerger from './adminpages/subclientmerger'; 
import Addrds from './adminpages/addrdsfile'; 
import DeleteTimesheet from './adminpages/deleteTimesheet';   
import BulkTimesheetUpload from './adminpages/BulkTimesheetUpload';
import BulkUserUpload from './adminpages/bulkusersupload'; 
import Multiapprover from './multiapprover';
import AdminReports from './adminpages/reports';
import AnalysisReports from './adminpages/analysisreports';
import Rdsreports from './adminpages/rdsreports';

import Bookkeepingbill from './adminpages/bookkeepingbill';
import ApiListings from './adminpages/apilistings';
import ApiTrigger from './adminpages/apitrigger';
import DeepAnalysisReport from './adminpages/deepanalysisReport';
import Addmainclient from './adminpages/addmainclient';
import Finalbillapproval from './adminpages/finalbillapproval';
import BulkUsersuploadnew from './adminpages/bulkusersuploadnew';
import Mulituploadv2 from './adminpages/mulituploadv2';
import AllUsersReports from './adminpages/allusersreports';

        
const Admin = () =>{

    const [users,setUsers] = useState([]);
    const [isloaded,setLoading] = useState(true); 
    const [isdialog,setuserdialog] = useState(false);
    const [isdialogedit,setusereditdialog] = useState(false); 
    const [totalpages,setPages] = useState([]);
    const [currentPage,setCurrentPage] = useState(1);
    const [last_page,setLastpage] = useState(1);
    const [per_page,setperpage] = useState(0);
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const roledata = localStorage.getItem('role') != '' && localStorage.getItem('role') != 'null' ? JSON.parse(localStorage.getItem('role')) : {};
    const permissionsvalue__ = localStorage.getItem('permissions') != '' ? JSON.parse(localStorage.getItem('permissions')) : {};

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [activeIndex, setActiveIndex] = useState(0);
    const [comp,setComp] = useState(<></>);
    const [activeMenu, setActiveMenu] = useState(null);
    const [permissionsstate,setPermissionsstate] = useState({});
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const toggleSidebar = () => {
      setSidebarVisible(!sidebarVisible);
    };

     
    useEffect(()=>{
      handlechange({value:1});
      permissions();
    },[]); 
    
    
    function handlechange({value}){
      setActiveMenu(value);
      switch(value){
        case 'addproject':
          setComp(<Addproject tabname={'Add Project'}/>);
          break;
        case 'addtask':
          setComp(<Addtask tabname={'Add Task'}/>);
          break;  
        case 'addclient':
          setComp(<Addclient tabname={'Add Client'}/>);
          break; 
        case 'addbudgethrs':
            setComp(<Addbudgethrs tabname={'Add Budget hrs'}/>);
            break; 
        case 'addroles':
              setComp(<Addroles tabname={'Add Roles'}/>);
              break;    
        case 'adddepartment':
          setComp(<Adddepartment tabname={'Add Department'}/>);
          break; 
        case 'addteam':
          setComp(<Addteams tabname={'Add Teams'}/>);
          break;  
        case 'clientmerger':
            setComp(<Clientmerger tabname={'Client Merger'}/>);
            break; 
            
        case 'clientAssinging':
            setComp(<Clientassign tabname={'Client Assinging'}/>);
            break;  
        case 'budgetclientwise':
              setComp(<Budgetclientwise tabname={'Add budget clientwise'}/>);
              break;
        case 'permissions':
          setComp(<Permissions tabname={'Roles & Permissions'}/>);
          break;   
        case 'mapmainclient':
            setComp(<Mapmainclient tabname={'Map Main Client'}/>);
            break;
        case 'addholiday':
          setComp(<Addholiday tabname={'Add Holiday'}/>);
          break;
        case 'subclientmerger':
            setComp(<SubClientmerger tabname={'Subclient Merger'}/>);
            break;
        case 'addrds':
          setComp(<Addrds tabname={'Update Rds file'}/>);  
          break;   
        case 'deletetms':
            setComp(<DeleteTimesheet tabname={'Delete Timesheet'}/>);  
          break; 
        case 'bulktimesheetupload':
          setComp(<BulkTimesheetUpload tabname={'Bulk Timesheet Upload'}/>);  
        break; 
        case 'bulkusersupload':
          setComp(<BulkUserUpload tabname={'Bulk Users Upload'}/>);  
        break; 
        
        case 'multiapprover' :
           setComp(<Multiapprover tabname={'Multi Approver'}/>);
        break;

        case 'reports' :
           setComp(<AdminReports tabname={'Reports'}/>);
        break;

        case 'bookkeepingbill':
          setComp(<Bookkeepingbill tabname={'Bookkeeping Bill'}/>);
        break;

        case 'analysisreports' :
           setComp(<AnalysisReports tabname={'Reports & Analysis'}/>);
        break;

        case 'rdssuperadminaccess' :
           setComp(<Rdsreports tabname={'Rds Reports'}/>);
        break;

        case 'rdsadminaccess' :
           setComp(<Rdsreports tabname={'Rds Reports'}/>);
        break;

        case 'apilistings':
           setComp(<ApiListings tabname={'API Listings'}/>);
        break;

        case 'apitrigger':
           setComp(<ApiTrigger tabname={'Api trigger'}/>);
        break;

        case 'deepanalysis':
           setComp(<DeepAnalysisReport tabname={'Deep Analysis Report'}/>);
        break;
        
        case 'addmainclient':
          setComp(<Addmainclient tabname={'Add Main Client'}/>);
        break;

        case 'finalbillapproval':
          setComp(<Finalbillapproval tabname={'Final Bill Approval'}/>);
        break;

        case 'bulkusersuploadnew':
          setComp(<BulkUsersuploadnew tabname={'Bulk Users Upload New'}/>);
        break;

        case 'mulituploadv2':
          setComp(<Mulituploadv2 tabname={'Multi User Upload (Excel Grid)'}/>);
        break;

        case 'allusersreports':
          setComp(<AllUsersReports tabname={'All Users Reports'}/>);
        break;

        default:
          setComp(<></>); 
          // setComp(<Addproject tabname={'Add Project'}/>); 
      }
    }

    function permissions(){
      if(permissionsvalue__ != null && permissionsvalue__ != undefined && permissionsvalue__[0] != undefined){
          let perobj = JSON.parse(permissionsvalue__[0].element);
          console.log(permissionsvalue__[0].element); 
          setPermissionsstate(perobj);  
      }
    }

    function displayadminside(){
      // console.log(permissionsstate[0].label,'permissionsstate');
      let temparr = [];
      
      const menuItem = (key, label, onClick, isActive) => (
        <li key={key}
          style={{ backgroundColor: isActive ? '#0891b2' : '', color: isActive ? '#ffffff' : '', fontWeight: isActive ? 600 : '', borderLeft: isActive ? '3px solid #0e7490' : '3px solid transparent', transition: 'all 0.2s', display: 'flex', alignItems: 'center', overflow: 'hidden' }}
          onClick={onClick}
          className="list-hover-effect custom-cursor-style list-group-item"
        >
          <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'left' }}>{label}</span>
          <FaAngleRight style={{ flexShrink: 0, marginLeft: '6px' }} />
        </li>
      );

      if(permissionsstate.length > 0){
          permissionsstate.forEach((values,index) => {
            if(values.value == 'yes'){
                const isActive = activeMenu === values.label;
                temparr.push(menuItem(values.label, values.text, () => handlechange({value: values.label}), isActive));
            }
          });

          if(roledata.rolename == 'superadmin'){
              temparr.push(menuItem('addholiday',   'Add Holiday',           () => handlechange({value:'addholiday'}),   activeMenu === 'addholiday'));
              temparr.push(menuItem('apilistings',  'API Listings',          () => handlechange({value:'apilistings'}),  activeMenu === 'apilistings'));
              temparr.push(menuItem('apitrigger',   'Api trigger',           () => handlechange({value:'apitrigger'}),   activeMenu === 'apitrigger'));
              temparr.push(menuItem('permissions',  'Roles & Permission',    () => handlechange({value:'permissions'}),  activeMenu === 'permissions'));
              temparr.push(menuItem('multiapprover','Multi Approver',        () => handlechange({value:'multiapprover'}),activeMenu === 'multiapprover'));
              temparr.push(menuItem('deepanalysis', 'Deep Analysis Report',  () => handlechange({value:'deepanalysis'}), activeMenu === 'deepanalysis'));
            
          }
          
      }else{
        // temparr.push(<li style={{textAlign:'left'}} onClick={()=> {
        //   setComp(<Mapmainclient tabname={'Map Main Client'}/>);
        // }} class="list-hover-effect custom-cursor-style list-group-item d-flex justify-content-between align-items-center">
        //     Map Main Client
        //   <span class="badge badge-primary badge-pill"></span>
        // </li>);
      }
      return temparr;
   }
     
    return(
        <>
         <div className="invisible-divider-sm"></div>
         <h6>Admin</h6>
         <div className="invisible-divider-sm"></div>
         <div className='card card-custom-style card-style-padding'>
          <div className="row">
            <div className="col-12 mb-3" style={{ display: 'flex', alignItems: 'center' }}>
              <button
                onClick={toggleSidebar}
                title={sidebarVisible ? 'Hide Sidebar' : 'Show Sidebar'}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '6px 8px',
                  borderRadius: '6px',
                  color: '#374151',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.15s ease',
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
                onMouseLeave={e => e.currentTarget.style.background = 'none'}
              >
                <FaBars style={{ fontSize: '18px' }} />
              </button>
            </div>
            {sidebarVisible && (
            <div className='col-md-2'>
              <div style={{ background: '#ffffff', borderRadius: '14px', border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 8px rgba(0,0,0,0.05), 0 0 1px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
                <ul className="list-group hoverlist-group" style={{ borderRadius: '14px', overflow: 'hidden', marginBottom: 0 }}>
                  {displayadminside()}
                </ul>
              </div>
            </div>)}
            <div className={sidebarVisible ? "col-md-10" : "col-md-12"}>
            <div className='card card-custom-style card-border-light'>
                {comp}
              </div>
            </div>
          </div>
          </div>
        </>
    ); 
}

export default Admin;